import { apiService } from "../../../services/apiService";
import { apiServiceConstants } from "../../../constants";
import { utilService } from "../../../services/utilService";

const patientAcceptance = async (params: any): Promise<any> => {
  const resApi = await apiService
    .apiCall(
      `ems/accept-case-patient/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as any;
      const result: any = {
        isSuccess: response.isSuccess,
        status: response.status,
        message: response.message,
      };
      return result;
    })
    .catch((error) => {
      const result: any = {
        isSuccess: false,
        message: error.message,
        status: error.status,
      };
      return result;
    });
  return resApi;
};

const emtAcceptData = async (params: any): Promise<any> => {
  const resApi = await apiService
    .apiCall(
      `ems/rejected-case-patients-seen/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as any;
      const result: any = {
        isSuccess: response.isSuccess,
        status: response.status,
        message: response.message,
      };
      return result;
    })
    .catch((error) => {
      const result: any = {
        isSuccess: false,
        message: error.message,
        status: error.status,
      };
      return result;
    });
  return resApi;
};

export const setPatientAcceptanceService = {
  patientAcceptance,
  emtAcceptData,
};
